import imgCupcakes from '../assets/img/works/design/cupcake_post.jpg';
import imgLuxLife from '../assets/img/works/design/luxlifenstyle.jpg';
import imgJustbnco from '../assets/img/works/design/justbncomenu.jpg';
import imgAlcohol from '../assets/img/works/design/iso_alcohol_packagin.jpg';
import imgFbCover from '../assets/img/works/design/fbcover.jpg';
import imgVWPOS from '../assets/img/works/design/vw_pos_brochure.jpg';
import imgOrc from '../assets/img/works/design/orc_illustrator.jpg';

import imgJustbncoweb from '../assets/img/works/website/justbncoweb.jpg';
import imgHeatwave from '../assets/img/works/website/heatwave.jpg';
import imgFvart from '../assets/img/works/website/fvart.jpg';
import imgHdt from '../assets/img/works/website/hdt.jpg';
import imgHealthluc from '../assets/img/works/website/healthluc.jpg';
import imgIoway from '../assets/img/works/website/iowaybeefarm.jpg';
import imgJournal from '../assets/img/works/website/journal.jpg';
import imgLg from '../assets/img/works/website/lgdigitour.jpg';

import imgCoke from '../assets/img/works/website/coke.jpg';
import imgTodo from '../assets/img/works/website/todolist.jpg';
import imgYellow from '../assets/img/works/website/yellow.jpg';
import imgGlass from '../assets/img/works/website/glassmorphism.jpg';
import imgMoon from '../assets/img/works/website/moonlight.jpg';

const Menu = [
    {
        id: 1,
        image: imgCupcakes,
        name: "Cupcake Post",
        category: "designs",
        description: 'Social Media Advertising Template.',
        tag: ["Figma ", " Adobe Illustrator"]
    },
    {
        id: 2,
        image: imgLuxLife,
        name:"Lux Life and Style",
        category: "designs",
        description: 'Web Design',
        tag: ["Adobe Photoshop "," Figma"]
    },
    {
        id: 3,
        image: imgJustbnco,
        name:"Just Bake & Co.",
        category: "designs",
        description: 'Just Bake & Co. Menu',
        tag: ["Adobe Photoshop "," Figma"]
    },
    {
        id: 4,
        image: imgAlcohol,
        name:"Isopropyl Alchohol",
        category: "designs",
        description: 'Isopropyl Alchohol Design',
        tag: ["Adobe Illustrator"]
    },
    {
        id: 5,
        image: imgFbCover,
        name:"Facebook Cover",
        category: "designs",
        description: 'Facebook Cover Design',
        tag: ["Figma", "Adobe Illustrator"]
    },
    {
        id: 6,
        image: imgVWPOS,
        name:"VanceWork POS",
        category: "designs",
        description: 'VanceWork POS Design',
        tag: ["Figma", "Adobe Illustrator"]
    },
    {
        id: 7,
        image: imgOrc,
        name:"Orc Vector",
        category: "designs",
        description: 'Orc Vector',
        tag: ["Adobe Illustrator"]
    },
    {
        id: 8,
        image: imgJustbncoweb,
        name:"Just Bake & Co.",
        category: "website",
        description: 'Just Bake & Co. Website',
        tag: ["Wordpress", "Elementor"]
    },
    {
        id: 9,
        image: imgHdt,
        name:"Home Defense Security",
        category: "website",
        description: 'Developed and redesigned the website of Home Defense Technology Corp.',
        url: "https://hdt.ph/",
        tag: ["Bootstrap 4 ", "HTML ", 'CSS']
    },
    {
        id: 10,
        image: imgLg,
        name:"LGDigitour",
        category: "reactjs",
        description: 'Participated on LG DIGITOUR, by making the website responsive using CSS and used json to get data such as products, and finish revisions.',
        url: "https://lgdigitour.com/",
        tag: ["ReactJS ", "Bootstrap 4"]
    },
    {
        id: 11,
        image: imgHeatwave,
        name:"Heatwave Plumbing",
        category: "website",
        description: 'Redesigned and developed Heatwave Plumbing site.',
        tag: ["Wordpress ", "Elementor"]
    },
    {
        id: 12,
        image: imgHealthluc,
        name:"Healthluc Med Distributor Inc.",
        category: "website",
        description: 'Developed the website for Healthluc Med Distribution Inc. using Wordpress with Elementor',
        url: "https://healthluc.com/",
        tag: ["Wordpress ", "Elementor"]
    },
    {
        id: 13,
        image: imgIoway,
        name:"IOWAY Bee Farm",
        category: "website",
        description: 'Worked on Wholesaler Application, Shipping Configuration worldwide, Email template, and revisions for IOWAYBEEFARM.',
        url: "https://iowaybeefarm.com/",
        tag: ["Wordpress ", "Elementor", " WooCommerce"]
    },
    {
        id: 14,
        image: imgJournal,
        name:"The Writer's Journal",
        category: "website",
        description: "Created a blog website using Elementor based on the design given for The Writer’s Journal.",
        url: "http://thewritersjournal.net/",
        tag: ["Wordpress ", "Elementor"]
    },
    {
        id: 15,
        image: imgFvart,
        name:"Fullvision Art",
        category: "website",
        description: 'Worked on whole WooCommerce configuration, design and develop customized frames / custom swatches.',
        url: "https://fullvisionart.co.uk/",
        tag: ["Wordpress ", "Elementor", 'WooCommerce']
    },
    {
        id: 16,
        image: imgCoke,
        name:"Coke Landing Page",
        category: "vuejs",
        description: 'This is a Landing Page create din Vue.js.',
        url: "https://coke-vuejs.netlify.app/#/",
        tag: ["Vue.js ", "HTML", 'CSS']
    },
    {
        id: 17,
        image: imgTodo,
        name:"TodoList App",
        category: "vuejs",
        description: 'TodoList App v1.0.0.',
        url: "https://todolistapp-vuejs.netlify.app/#/",
        tag: ["Vue.js ", "HTML", 'CSS']
    },
    {
        id: 18,
        image: imgYellow,
        name:"My Happy Color",
        category: "reactjs",
        description: 'Created in ReactJS.',
        url: "https://my-happy-color.netlify.app/",
        tag: ["ReactJS", "HTML", 'CSS']
    },
    {
        id: 19,
        image: imgGlass,
        name:"Glassmorphism Popup",
        category: "reactjs",
        description: 'Created in ReactJS.',
        url: "https://react-glassmorphism-popup.netlify.app/",
        tag: ["ReactJS", "HTML", 'CSS']
    },
    {
        id: 20,
        image: imgMoon,
        name:"Moonlight Parallax",
        category: "website",
        description: 'Moonlight Parallax is made to practice basic HTML, CSS and JS.',
        url: "https://moonlight-parallax-html-css.netlify.app/",
        tag: ["JavaScript", "HTML", 'CSS']
    }
];



export default Menu;